import { useState } from "react";
import { AxiosError } from "axios";

// Generic type for form validation errors
export type ValidationError = {
    message: string;
    errors: { [key: string]: string[] };
};

// Custom hook for handling form validation errors
export function useFormErrors() {
    const [formErrors, setFormErrors] = useState<ValidationError>({} as ValidationError);

    // Function to handle errors, specifically Axios errors
    const handleError = (error: AxiosError) => {
        if (error.response && error.response.data) {
            setFormErrors(error.response.data as ValidationError);
        } else {
            console.error("Unexpected error format:", error);
        }
    };

    // Function to clear errors after successful submission
    const clearErrors = () => {
        setFormErrors({} as ValidationError);
    };

    // Function to render errors for a specific field
    const renderError = (field: string) => {
        if (formErrors && formErrors.errors && formErrors.errors[field]) {
            return (
                <div className="text-danger">
                    {formErrors.errors[field].map((err, index) => (
                        <p key={index}>{err}</p>
                    ))}
                </div>
            );
        }
        return null;
    };

    return { formErrors, handleError, clearErrors, renderError };
}
